import styled from 'styled-components'
import blueGradientBlobs from '~/assets/blu-gradient-blobs-02.png'
import { backgroundBoxShadow } from '~/components/CommonStyles'
import { dimensions, light, spacing } from '~/constants/theme'

export const RootWrapper = styled.div`
  height: 100vh;
  min-height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  background-image: url(${blueGradientBlobs});
  background-size: cover;
  background-repeat: no-repeat;
`

export const ContentWrapper = styled.div`
  width: 33%;
  max-width: 400px;
  min-width: 320px;
  max-height: 650px;
  padding: ${spacing.spacingXL};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: ${dimensions.borderRadiusMD};
  box-sizing: border-box;
  background-color: white;
  ${backgroundBoxShadow};
`

export const LogoImage = styled.img<{ src: string }>`
  width: 100%;
  max-width: 200px;
  min-width: 200px;
  height: auto;
  margin: ${spacing.spacingXXXL} auto;
  src: url(${({ src }) => src});
`

export const ErrorWrapper = styled.div`
  width: 90%;
  display: flex;
  align-items: center;
  margin-bottom: ${spacing.spacingMD};
`

export const InputWrapper = styled.div`
  width: 90%;
  min-width: 200px;
  margin-bottom: ${spacing.spacingLG};
  border-radius: ${dimensions.borderRadiusSM};
  position: relative;
`

export const PassButtonWrapper = styled.div`
  position: absolute;
  top: 0;
  right: 10px;
`

export const LoginButtonWrapper = styled.div`
  margin: ${spacing.spacingXXXL} 0px;
  width: 100%;
  min-width: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const ForgotButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: ${spacing.spacingLG};
`

export const ForgotButton = styled.div`
  cursor: pointer;
`

export const Wrapper = styled.div`
  width: 33vw;
  max-width: 642px;
  min-width: 400px;
  max-height: 650px;
  padding: 60px 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: ${dimensions.borderRadiusMD};
  box-sizing: border-box;
  background-color: white;
  ${backgroundBoxShadow};
`

export const TitleWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: ${spacing.spacingLG};
`

export const PbxWrapper = styled.div`
  width: 100%;
  margin: ${spacing.spacingXL} 0px;
  overflow: auto;
  box-sizing: border-box;
  border: 2px solid var(--Gray-Gray400, #e5e5ee);
  border-radius: 20px;
  padding: 40px;
  background-color: ${light.gray100};
`

export const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: ${spacing.spacingLG};
  > div {
    margin: 0 6px;
  }
`

export const HelpWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 20px;
  gap: 16px;
`

export const EmptyWrapper = styled(Wrapper)`
  padding: 60px 80px;
`
